import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'History|Exams';

export type ExamsLoc =
	| 'CPExamsScaledScoreLabel'
	| 'CPExamsFilterByGroupLabel'
	| 'CPExamsPageTitle'
	| 'CPExamsPageDescription'
	| 'CPExamHistoryDownloadLabel'
	| 'CPExamHistoryGradeLabel'
	| 'CPExamHistoryNameLabel'
	| 'CPExamHistoryCodeLabel'
	| 'CPExamHistoryExamDateLabel'
	| 'CPExamHistoryExpiresLabel'
	| 'CPExamHistoryRegistrationNumberLabel'
	| 'CPExamHistoryScaledScoreLabel'
	| 'CPExamHistoryGroupLabel'
	| 'CPExamHistoryNeverValue';

export const cpExamsLocs: LocDefs<ExamsLoc> = {
	CPExamsScaledScoreLabel: {
		defaultValue: 'Scaled Score',
		description: 'Label for scaled score.',
		displayPath: `${dpRoot}|Scaled Score`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'CP',
	},
	CPExamsFilterByGroupLabel: {
		defaultValue: 'Filter by Group',
		displayPath: `${dpRoot}|Filter by Group Label`,
		description: 'Label for filter by group.',
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'CP',
	},
	CPExamsPageTitle: {
		defaultValue: 'Exams',
		description: 'Page title for the exams page',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.Title.PageTitle',
	},
	CPExamsPageDescription: {
		defaultValue: '',
		description: 'Page description for the exams page',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		htmlAllowed: true,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.Content.PageDescription',
	},
	CPExamHistoryDownloadLabel: {
		defaultValue: 'Download',
		description: 'Label for actions column',
		displayPath: `${dpRoot}|Actions`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.Download',
	},
	CPExamHistoryGradeLabel: {
		defaultValue: 'Grade',
		description: 'Label for grade column',
		displayPath: `${dpRoot}|Grade`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.Grade',
	},
	CPExamHistoryNameLabel: {
		defaultValue: 'Name',
		description: 'Label for name column',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.Name',
	},
	CPExamHistoryCodeLabel: {
		defaultValue: 'Code',
		description: 'Label for code column',
		displayPath: `${dpRoot}|Code`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.Code',
	},
	CPExamHistoryExamDateLabel: {
		defaultValue: 'Exam Date',
		description: 'Label for exam date column',
		displayPath: `${dpRoot}|Exam Date`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.ExamDate',
	},
	CPExamHistoryExpiresLabel: {
		defaultValue: 'Expires',
		description: 'Label for expires column',
		displayPath: `${dpRoot}|Expires`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.Expires',
	},
	CPExamHistoryRegistrationNumberLabel: {
		defaultValue: 'Registration Number',
		description: 'Label for registration number column',
		displayPath: `${dpRoot}|Registration Number`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.RegistrationNumber',
	},
	CPExamHistoryScaledScoreLabel: {
		defaultValue: 'Scaled Score',
		description: 'Label for scaled score column',
		displayPath: `${dpRoot}|Scaled Score`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.ScaledScore',
	},
	CPExamHistoryGroupLabel: {
		defaultValue: 'Group',
		description: 'Label for group column',
		displayPath: `${dpRoot}|Group`,
		displayType: 'Label',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.GroupName',
	},
	CPExamHistoryNeverValue: {
		defaultValue: 'Never',
		description: 'Displayed value for never',
		displayPath: `${dpRoot}|Never`,
		displayType: 'Content',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.Exam,
		portal: 'CP',
		legacyName: 'Exam/History.Exams.FieldLabel.ExpireDateNever',
	},
};

export const LOC_KEYS = MapLocKeys<ExamsLoc>(cpExamsLocs);
export type CPExamsLocKeys = typeof LOC_KEYS;
